import React from 'react';
import { expVal } from '@atlassian/jira-feature-experiments';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/JSErrorBoundary.tsx';
import { FireTrackAnalytics } from '@atlassian/jira-product-analytics-bridge';
import { useIsCrossFlowEligible, useIsCoUseEligible } from '../utils.tsx';

export const useIsExperimentEligibleAA = () => {
	const isCrossFlowEligible = useIsCrossFlowEligible();
	const isCoUseEligible = useIsCoUseEligible();
	let cohort = 'not-enrolled';

	if (isCrossFlowEligible || isCoUseEligible) {
		cohort = expVal('grw_1416_update_plan_whiteboards_aa', 'cohort', 'not-enrolled');
	}
	return cohort;
};

const AAExperiment = () => {
	const cohort = useIsExperimentEligibleAA();

	return (
		<FireTrackAnalytics
			eventName="whiteboards-refresh-button-aa viewed"
			attributes={{ cohort, experiment: 'grw_1416_update_plan_whiteboards_aa' }}
		/>
	);
};

export const WhiteboardsButtonAA = () => {
	return (
		<JSErrorBoundary
			id="whiteboards-button-ui-refresh-aa"
			packageName="jira-software-backlog"
			teamName="starburst"
		>
			<AAExperiment />
		</JSErrorBoundary>
	);
};
